import {
  DataTypeProvider,
  type DataTypeProviderProps,
} from "@devexpress/dx-react-grid";

const CountTokenFormatter = ({
  value,
}: DataTypeProvider.ValueFormatterProps) => (
  <div className="flex items-center justify-end">
    <div className="bg-interstellar-3 text-v2-primary rounded-md px-1.5 py-0.5 text-xs">
      {value}
    </div>
  </div>
);

export const CountTokenTypeProvider = (props: DataTypeProviderProps) => (
  <DataTypeProvider formatterComponent={CountTokenFormatter} {...props} />
);
